import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

export enum RedirectRoutes {
  "Plugin"
}

@Component({
  selector: 'app-redirects',
  standalone: true,
  imports: [],
  template: ``,
  styles: ``
})
export class RedirectsComponent {
  activatedRoute = inject(ActivatedRoute)
  router = inject(Router)

  constructor() {
    const location = this.activatedRoute.snapshot.paramMap.get("linkage")
    switch(location) {
      case 'devforum': {
        this.redirect("https://devforum.roblox.com/t/rorender-v4-minimap-generator/3525559")
        return
      }
      case 'plugin': {
        this.redirect("https://create.roblox.com/store/asset/102372310431390/RoRenderV4")
        return
      }
      default: {
        this.router.navigate(['home'])
        return
      }
    }
  }

  redirect(location: string){
    window.location.href = location
  }
}
